
import BaseMixin from '@/views/mixin.vue'
import { mapState, mapGetters } from 'vuex'

import { HttpVsAllotList, HttpDelVsAllot, HttpActiveVsAllot } from '@/service/boss/allot';

import compSearch from './search';
import compDetail from './detail';
import compUpdate from './update';

import { Dropdown, Icon, Button } from 'view-design'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compDetail,
        compUpdate,
    },
    data () {
        return {
            data: [],
            checkedId: [],
        };
    },
    methods: {
        httpList: HttpVsAllotList,
        handleOperates (id, type, row) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        id,
                        title: this.$t('global.common.query',{defaultValue:'查看'}),
                        component: 'compDetail',
                        show: true,
                        width: 720,
                        footer: false,
                    }; break;
                case 'active':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        id,
                        type,
                        title: this.$t('fbb.accountmanage.active_opearte',{defaultValue:'激活操作'})
                    }; break;
                case 'edit':
                    this.$router.push({ name: "vsAllotDetail", params: { type: 'edit' }, query: { id } })
                    break;
                case 'cancel':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        type,
                        title: this.$t('global.common.operatecancel',{defaultValue:'取消操作'})
                    }; break;
                case 'add':
                    this.$router.push({ name: "vsAllotDetail", params: { type: 'add' } })
                    break;
                case 'upload':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2c.import_data',{defaultValue:'导入数据'}),
                        data: { contextId: global.SYSID },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTransfer/import",
                        name: "excelFile",
                        component: "compUpload",
                        showdownload: true,
                        download: this.download,
                        refresh: this.updateList
                    }
                    break;
                case 'exportdd':
                    // console.log(23423423423)
                    // console.log(this.formData,'this.formData')
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTransfer/export", this.formData, 'download')
                    break;
            }
        },
        download () {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTransfer/excel", {}, 'download')
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'active': request = HttpActiveVsAllot; params = { ids: this.checkedId.join(',') || id }; break;
                case 'cancel': request = HttpDelVsAllot; params = { ids: this.checkedId.join(',') || id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
    },
    computed: {
        // ...mapState('boss',['products']),
        ...mapGetters('boss', ['warehouses']),
        ...mapGetters('diction', ['getNewProductList']),
        columns () {
            return [{
                width: 60,
                type: "selection",
            }, {
                title: this.$t('global.common.operate',{defaultValue:'操作'}),
                width: 180,
                render: (h, { row }) => {
                    const id = row.id, show = row.status === 'DRAFT';
                    return <div>
                        <Button size='small' type='primary' class="margin-right-5" onClick={this.handleOperates.bind(this, id, 'query')}>{this.$t('global.common.query',{defaultValue:'查看'})}</Button>
                        <Button v-show={show} size='small' type='primary' class="margin-right-5" onClick={this.handleOperates.bind(this, id, 'active')}>{this.$t('erp.channel.active',{defaultValue:'激活'})}</Button>
                        <Button v-show={show} size='small' type='success' onClick={this.handleOperates.bind(this, id, 'edit')}>{this.$t('global.common.edit',{defaultValue:'编辑'})}</Button>
                    </div>
                }
            }, {
                title: '#ID',
                width: 80,
                key: 'id',
                sortable: true,
            },
            {
                title: this.$t('erp.virtualstore.transferordernum',{defaultValue:'调拨单号'}),
                key: 'transferNo',
                sortable: true,
                render: (h, { row }) => {
                    return <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.transferNo}</a>
                }
            },
            {
                title: this.$t('global.common.project',{defaultValue:'项目'}),
                key: 'lineId',
                sortable: true,
                render: (h, { row }) => {
                    const id = row.lineId;
                    const product = this.getNewProductList.filter((item) => {
                        return id === item.value
                    })[0] || {};
                    return <span>{product.label}</span>
                },
            },
            {
                title: this.$t('erp.virtualstore.actualoutwarehouse',{defaultValue:'实际出库仓库'}),
                key: 'orgWarehouseId',
                sortable: true,
                render: (h, { row }) => {
                    const id = row.orgWarehouseId;
                    const weraehouse = this.warehouses.filter((item) => {
                        return id === item.id
                    })[0] || {};
                    return <span>{weraehouse.title}</span>
                },
            },
            {
                title: this.$t('erp.virtualstore.virtualoutware',{defaultValue:'虚拟出库仓'}),
                key: 'outWarehouseCode',
                sortable: true,
            }, {
                title: this.$t('erp.virtualstore.virtualinware',{defaultValue:'虚拟入库仓'}),
                key: "inWarehouseCode",
            }, {
                title: this.$t('fbb.adjustment.created_name',{defaultValue:'创建人'}),
                key: "createdName",

            }, {
                title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                key: 'updatedAt',
                width: 160,

            }, {
                title: this.$t('global.common.status',{defaultValue:'状态'}),
                width: 80,
                key: 'status',
                sortable: true,
                render :(h, { row })=> {
                    switch (row.status) {
                        case "ACTIVATE": return <Button class="cursor-default" type='success' size='small'>{this.$t('erp.channel.active',{defaultValue:'激活'})}</Button>; break;
                        case "CANCEL": return <Button class="cursor-default" type='error' size='small'>{this.$t('global.common.operation_cancel',{defaultValue:'取消'})}</Button>; break;
                        case "DRAFT": return <Button class="cursor-default" type='primary' size='small'>{this.$t('fbb.alloment.draft',{defaultValue:'草稿'})}</Button>; break;
                    }
                }
            },];
        },
    },
};




